import { ShoppingCart, X, CheckCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n";
import type { OrderNotification } from "@/hooks/use-waiter-calls";

function timeAgo(ts: number) {
  const diff = Math.floor((Date.now() - ts) / 1000);
  if (diff < 60) return `${diff}sn once`;
  if (diff < 3600) return `${Math.floor(diff / 60)}dk once`;
  return new Date(ts).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
}

export function OrderNotificationPanel({
  orders,
  onDismiss,
  onDismissAll,
}: {
  orders: OrderNotification[];
  onDismiss: (id: string) => void;
  onDismissAll: () => void;
}) {
  const { t } = useI18n();

  if (orders.length === 0) return null;

  return (
    <div className="w-80">
      <div className="rounded-xl border bg-card shadow-2xl overflow-hidden animate-in slide-in-from-right">
        <div className="flex items-center justify-between bg-orange-500 px-4 py-3 text-white">
          <div className="flex items-center gap-2">
            <ShoppingCart className="size-4 animate-bounce" />
            <span className="font-semibold text-sm">
              {t("new_order_notification")} ({orders.length})
            </span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-7 text-xs text-white hover:bg-white/20"
            onClick={onDismissAll}
          >
            <CheckCheck className="mr-1 size-3" />
            {t("all")}
          </Button>
        </div>

        <div className="max-h-64 overflow-y-auto divide-y">
          {orders.map((order) => (
            <div
              key={order.id}
              className="flex items-center justify-between px-4 py-3 hover:bg-muted/50 transition-colors"
            >
              <div>
                <div className="font-semibold text-sm">{order.table}</div>
                <div className="text-xs text-muted-foreground">
                  {timeAgo(order.timestamp)}
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                className="size-7 shrink-0"
                onClick={() => onDismiss(order.id)}
              >
                <X className="size-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
